import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Users, FileText, DollarSign, TrendingUp, Sparkles } from "lucide-react";

export default function AdminHome() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/admin/stats").then(r => setS(r.data)); }, []);
  const cards = [
    { l: "Total users", v: s.totalUsers || 0, i: Users, c: "text-indigo-300" },
    { l: "Documents", v: s.totalDocuments || 0, i: FileText, c: "text-cyan-300" },
    { l: "Words processed", v: (s.totalWordsProcessed || 0).toLocaleString(), i: Sparkles, c: "text-emerald-300" },
    { l: "Total revenue (ZAR)", v: `R${(s.totalRevenue || 0).toLocaleString()}`, i: DollarSign, c: "text-amber-300" },
    { l: "Pro subscribers", v: s.proUsers || 0, i: TrendingUp, c: "text-indigo-300" },
    { l: "Business subscribers", v: s.businessUsers || 0, i: TrendingUp, c: "text-purple-300" },
  ];
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14">
      <div className="flex items-center gap-3">
        <span className="px-2 py-1 rounded-md bg-red-500/20 border border-red-500/40 text-red-300 text-[10px] tracking-widest uppercase glow-error">ADMIN</span>
        <div className="text-xs uppercase tracking-[0.25em] text-zinc-500">Overview</div>
      </div>
      <h1 className="mt-2 text-3xl sm:text-4xl font-bold tracking-tight" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Platform pulse</h1>
      <div className="mt-8 grid md:grid-cols-3 gap-4">
        {cards.map((c, i) => (
          <div key={i} className="glass-strong rounded-2xl p-6">
            <c.i size={18} className={c.c}/>
            <div className="mt-3 text-3xl font-bold" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>{c.v}</div>
            <div className="text-xs uppercase tracking-widest text-zinc-400 mt-1">{c.l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
